var map = {
	"./ansys.jpg": 5336,
	"./blender.jpg": 852,
	"./inventor.jpg": 9629,
	"./linux_commands.jpg": 2841,
	"./premier_pro.jpg": 7600,
	"./proteus.png": 7548,
	"./solidworks_workshop.jpg": 7547,
	"./stock_market.jpeg": 416
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9484;